var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _path, _path2, _path3, _path4, _path5, _path6, _text, _g, _text2, _text3, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrTagVl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 368.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bfe2f7;\n        font-size: 8.17px;\n      }\n\n      .cls-1, .cls-2 {\n        font-family: Barlow-Regular, Barlow;\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #0077f9;\n      }\n\n      .cls-5 {\n        font-family: Barlow-Medium, Barlow;\n        font-size: 11.75px;\n        font-weight: 500;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        font-size: 38.95px;\n      }\n\n      .cls-7, .cls-8 {\n        fill: #0db504;\n      }\n\n      .cls-9 {\n        font-size: 28.38px;\n      }\n\n      .cls-10 {\n        letter-spacing: 0em;\n      }\n\n      .cls-11, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-12 {\n        letter-spacing: -.07em;\n      }\n\n      .cls-13 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-14 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-15 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-16 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-17 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-18 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-19 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-20 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-21 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-22 {\n        font-family: Barlow-ExtraBold, Barlow;\n        font-weight: 700;\n      }\n\n      .cls-23 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-24 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-25 {\n        letter-spacing: 0em;\n      }\n\n      .cls-26 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-27 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-28 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-29 {\n        letter-spacing: 0em;\n      }\n\n      .cls-30 {\n        letter-spacing: 0em;\n      }\n\n      .cls-31 {\n        letter-spacing: 0em;\n      }\n\n      .cls-32 {\n        letter-spacing: 0em;\n      }\n\n      .cls-33 {\n        letter-spacing: 0em;\n      }\n\n      .cls-34 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        font-size: 9.33px;\n      }\n\n      .cls-35 {\n        letter-spacing: 0em;\n      }\n\n      .cls-36 {\n        fill: #d4edff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    width: 198.43,
    height: 181.89
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 181.89,
    width: 198.43,
    height: 186.61
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 33.27,
    y: 204.77,
    width: 131.85,
    height: 132.28
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 209.78,
    width: 4.21,
    height: 4.21
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2,
    y: 209.78,
    width: 4.21,
    height: 4.21
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 209.78,
    width: 4.21,
    height: 4.21
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 209.78,
    width: 4.21,
    height: 4.21
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 209.78,
    width: 4.21,
    height: 4.21
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 209.78,
    width: 4.21,
    height: 4.21
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 209.78,
    width: 4.21,
    height: 4.21
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 213.99,
    width: 4.21,
    height: 4.21
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 213.99,
    width: 4.21,
    height: 4.21
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 213.99,
    width: 4.21,
    height: 4.21
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 105.48,
    y: 213.99,
    width: 4.21,
    height: 4.21
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 109.69,
    y: 213.99,
    width: 4.21,
    height: 4.21
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 213.99,
    width: 4.21,
    height: 4.21
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 218.21,
    width: 4.21,
    height: 4.21
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 75.99,
    y: 218.21,
    width: 4.21,
    height: 4.21
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 218.21,
    width: 4.21,
    height: 4.21
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 218.21,
    width: 4.21,
    height: 4.21
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 105.48,
    y: 218.21,
    width: 4.21,
    height: 4.21
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 218.21,
    width: 4.21,
    height: 4.21
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 218.21,
    width: 4.21,
    height: 4.21
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2,
    y: 222.42,
    width: 4.21,
    height: 4.21
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 84.41,
    y: 222.42,
    width: 4.21,
    height: 4.21
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 222.42,
    width: 4.21,
    height: 4.21
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 222.42,
    width: 4.21,
    height: 4.21
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 101.27,
    y: 222.42,
    width: 4.21,
    height: 4.21
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 109.69,
    y: 222.42,
    width: 4.21,
    height: 4.21
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 222.42,
    width: 4.21,
    height: 4.21
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 222.42,
    width: 4.21,
    height: 4.21
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 75.99,
    y: 226.63,
    width: 4.21,
    height: 4.21
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2,
    y: 226.63,
    width: 4.21,
    height: 4.21
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 226.63,
    width: 4.21,
    height: 4.21
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 226.63,
    width: 4.21,
    height: 4.21
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 226.63,
    width: 4.21,
    height: 4.21
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 230.85,
    width: 4.21,
    height: 4.21
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 75.99,
    y: 230.85,
    width: 4.21,
    height: 4.21
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2,
    y: 230.85,
    width: 4.21,
    height: 4.21
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 230.85,
    width: 4.21,
    height: 4.21
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 101.27,
    y: 230.85,
    width: 4.21,
    height: 4.21
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 230.85,
    width: 4.21,
    height: 4.21
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 230.85,
    width: 4.21,
    height: 4.21
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 235.06,
    width: 4.21,
    height: 4.21
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2,
    y: 235.06,
    width: 4.21,
    height: 4.21
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 235.06,
    width: 4.21,
    height: 4.21
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 235.06,
    width: 4.21,
    height: 4.21
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 105.48,
    y: 235.06,
    width: 4.21,
    height: 4.21
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 235.06,
    width: 4.21,
    height: 4.21
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 235.06,
    width: 4.21,
    height: 4.21
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 239.27,
    width: 4.21,
    height: 4.21
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 75.99,
    y: 239.27,
    width: 4.21,
    height: 4.21
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 239.27,
    width: 4.21,
    height: 4.21
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 101.27,
    y: 239.27,
    width: 4.21,
    height: 4.21
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 105.48,
    y: 239.27,
    width: 4.21,
    height: 4.21
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 239.27,
    width: 4.21,
    height: 4.21
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 239.27,
    width: 4.21,
    height: 4.21
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 239.27,
    width: 4.21,
    height: 4.21
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 46.49,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 54.92,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 63.35,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 84.41,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 126.55,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 151.83,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 243.49,
    width: 4.21,
    height: 4.21
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 38.07,
    y: 247.7,
    width: 4.21,
    height: 4.21
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 54.92,
    y: 247.7,
    width: 4.21,
    height: 4.21
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 59.13,
    y: 247.7,
    width: 4.21,
    height: 4.21
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 126.55,
    y: 247.7,
    width: 4.21,
    height: 4.21
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 247.7,
    width: 4.21,
    height: 4.21
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 247.7,
    width: 4.21,
    height: 4.21
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 151.83,
    y: 247.7,
    width: 4.21,
    height: 4.21
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 247.7,
    width: 4.21,
    height: 4.21
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 42.28,
    y: 251.91,
    width: 4.21,
    height: 4.21
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 46.49,
    y: 251.91,
    width: 4.21,
    height: 4.21
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 251.91,
    width: 4.21,
    height: 4.21
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 54.92,
    y: 251.91,
    width: 4.21,
    height: 4.21
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 59.13,
    y: 251.91,
    width: 4.21,
    height: 4.21
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 63.35,
    y: 251.91,
    width: 4.21,
    height: 4.21
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 251.91,
    width: 4.21,
    height: 4.21
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 251.91,
    width: 4.21,
    height: 4.21
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 251.91,
    width: 4.21,
    height: 4.21
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 54.92,
    y: 256.13,
    width: 4.21,
    height: 4.21
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 59.13,
    y: 256.13,
    width: 4.21,
    height: 4.21
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 256.13,
    width: 4.21,
    height: 4.21
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 256.13,
    width: 4.21,
    height: 4.21
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 256.13,
    width: 4.21,
    height: 4.21
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 256.13,
    width: 4.21,
    height: 4.21
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 256.13,
    width: 4.21,
    height: 4.21
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 38.07,
    y: 260.34,
    width: 4.21,
    height: 4.21
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 42.28,
    y: 260.34,
    width: 4.21,
    height: 4.21
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 59.13,
    y: 260.34,
    width: 4.21,
    height: 4.21
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 63.35,
    y: 260.34,
    width: 4.21,
    height: 4.21
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 260.34,
    width: 4.21,
    height: 4.21
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 126.55,
    y: 260.34,
    width: 4.21,
    height: 4.21
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 260.34,
    width: 4.21,
    height: 4.21
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 260.34,
    width: 4.21,
    height: 4.21
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 151.83,
    y: 260.34,
    width: 4.21,
    height: 4.21
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 38.07,
    y: 264.55,
    width: 4.21,
    height: 4.21
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 54.92,
    y: 264.55,
    width: 4.21,
    height: 4.21
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 67.56,
    y: 264.55,
    width: 4.21,
    height: 4.21
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 264.55,
    width: 4.21,
    height: 4.21
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 264.55,
    width: 4.21,
    height: 4.21
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 264.55,
    width: 4.21,
    height: 4.21
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 264.55,
    width: 4.21,
    height: 4.21
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 264.55,
    width: 4.21,
    height: 4.21
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 264.55,
    width: 4.21,
    height: 4.21
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 42.28,
    y: 268.77,
    width: 4.21,
    height: 4.21
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 268.77,
    width: 4.21,
    height: 4.21
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 54.92,
    y: 268.77,
    width: 4.21,
    height: 4.21
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 59.13,
    y: 268.77,
    width: 4.21,
    height: 4.21
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 63.35,
    y: 268.77,
    width: 4.21,
    height: 4.21
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 67.56,
    y: 268.77,
    width: 4.21,
    height: 4.21
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 268.77,
    width: 4.21,
    height: 4.21
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 268.77,
    width: 4.21,
    height: 4.21
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 268.77,
    width: 4.21,
    height: 4.21
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 268.77,
    width: 4.21,
    height: 4.21
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 42.28,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 46.49,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 54.92,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 59.13,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 67.56,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 126.55,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 151.83,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 272.98,
    width: 4.21,
    height: 4.21
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 277.2,
    width: 4.21,
    height: 4.21
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 54.92,
    y: 277.2,
    width: 4.21,
    height: 4.21
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 63.35,
    y: 277.2,
    width: 4.21,
    height: 4.21
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 67.56,
    y: 277.2,
    width: 4.21,
    height: 4.21
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 277.2,
    width: 4.21,
    height: 4.21
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 38.07,
    y: 281.41,
    width: 4.21,
    height: 4.21
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 46.49,
    y: 281.41,
    width: 4.21,
    height: 4.21
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 67.56,
    y: 281.41,
    width: 4.21,
    height: 4.21
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 281.41,
    width: 4.21,
    height: 4.21
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 281.41,
    width: 4.21,
    height: 4.21
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 281.41,
    width: 4.21,
    height: 4.21
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 281.41,
    width: 4.21,
    height: 4.21
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 151.83,
    y: 281.41,
    width: 4.21,
    height: 4.21
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 38.07,
    y: 285.62,
    width: 4.21,
    height: 4.21
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 46.49,
    y: 285.62,
    width: 4.21,
    height: 4.21
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 285.62,
    width: 4.21,
    height: 4.21
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 54.92,
    y: 285.62,
    width: 4.21,
    height: 4.21
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 63.35,
    y: 285.62,
    width: 4.21,
    height: 4.21
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 285.62,
    width: 4.21,
    height: 4.21
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 285.62,
    width: 4.21,
    height: 4.21
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 126.55,
    y: 285.62,
    width: 4.21,
    height: 4.21
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 285.62,
    width: 4.21,
    height: 4.21
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 38.07,
    y: 289.84,
    width: 4.21,
    height: 4.21
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 289.84,
    width: 4.21,
    height: 4.21
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 59.13,
    y: 289.84,
    width: 4.21,
    height: 4.21
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 67.56,
    y: 289.84,
    width: 4.21,
    height: 4.21
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 289.84,
    width: 4.21,
    height: 4.21
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 289.84,
    width: 4.21,
    height: 4.21
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 289.84,
    width: 4.21,
    height: 4.21
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 289.84,
    width: 4.21,
    height: 4.21
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 151.83,
    y: 289.84,
    width: 4.21,
    height: 4.21
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 289.84,
    width: 4.21,
    height: 4.21
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 38.07,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 50.71,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 63.35,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 67.56,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 126.55,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 151.83,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 294.05,
    width: 4.21,
    height: 4.21
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 101.27,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 105.48,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 298.26,
    width: 4.21,
    height: 4.21
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2,
    y: 302.48,
    width: 4.21,
    height: 4.21
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 302.48,
    width: 4.21,
    height: 4.21
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 109.69,
    y: 302.48,
    width: 4.21,
    height: 4.21
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 302.48,
    width: 4.21,
    height: 4.21
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 302.48,
    width: 4.21,
    height: 4.21
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 302.48,
    width: 4.21,
    height: 4.21
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 302.48,
    width: 4.21,
    height: 4.21
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 302.48,
    width: 4.21,
    height: 4.21
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 302.48,
    width: 4.21,
    height: 4.21
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 151.83,
    y: 302.48,
    width: 4.21,
    height: 4.21
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2,
    y: 306.69,
    width: 4.21,
    height: 4.21
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 306.69,
    width: 4.21,
    height: 4.21
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 306.69,
    width: 4.21,
    height: 4.21
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 306.69,
    width: 4.21,
    height: 4.21
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 306.69,
    width: 4.21,
    height: 4.21
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 151.83,
    y: 306.69,
    width: 4.21,
    height: 4.21
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 306.69,
    width: 4.21,
    height: 4.21
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 75.99,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 84.41,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 101.27,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 126.55,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 310.9,
    width: 4.21,
    height: 4.21
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 315.12,
    width: 4.21,
    height: 4.21
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 75.99,
    y: 315.12,
    width: 4.21,
    height: 4.21
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 315.12,
    width: 4.21,
    height: 4.21
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 109.69,
    y: 315.12,
    width: 4.21,
    height: 4.21
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 315.12,
    width: 4.21,
    height: 4.21
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 315.12,
    width: 4.21,
    height: 4.21
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 126.55,
    y: 315.12,
    width: 4.21,
    height: 4.21
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 315.12,
    width: 4.21,
    height: 4.21
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 315.12,
    width: 4.21,
    height: 4.21
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 315.12,
    width: 4.21,
    height: 4.21
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 71.77,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 75.99,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 92.84,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 101.27,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 105.48,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 109.69,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 126.55,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 147.62,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 151.83,
    y: 319.33,
    width: 4.21,
    height: 4.21
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 75.99,
    y: 323.54,
    width: 4.21,
    height: 4.21
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 88.63,
    y: 323.54,
    width: 4.21,
    height: 4.21
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 323.54,
    width: 4.21,
    height: 4.21
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 109.69,
    y: 323.54,
    width: 4.21,
    height: 4.21
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 323.54,
    width: 4.21,
    height: 4.21
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 323.54,
    width: 4.21,
    height: 4.21
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 323.54,
    width: 4.21,
    height: 4.21
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 323.54,
    width: 4.21,
    height: 4.21
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 156.04,
    y: 323.54,
    width: 4.21,
    height: 4.21
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 97.05,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 101.27,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 109.69,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 113.91,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 122.33,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 126.55,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 130.76,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 134.97,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 139.19,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 327.76,
    width: 4.21,
    height: 4.21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.96,209.78c-.49,0-.9.4-.9.9v27.71c0,.49.4.9.9.9h27.71c.49,0,.9-.4.9-.9v-27.71c0-.49-.4-.9-.9-.9h-27.71ZM63.35,218.21v16.34c0,.29-.23.51-.51.51h-20.04c-.29,0-.51-.23-.51-.51v-20.04c0-.29.23-.51.51-.51h20.04c.29,0,.51.23.51.51v3.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.13,226.63v-7.53c0-.49-.4-.9-.9-.9h-10.85c-.49,0-.9.4-.9.9v10.85c0,.49.4.9.9.9h10.85c.49,0,.9-.4.9-.9v-3.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.65,209.78c-.49,0-.9.4-.9.9v27.71c0,.49.4.9.9.9h27.71c.49,0,.9-.4.9-.9v-27.71c0-.49-.4-.9-.9-.9h-27.71ZM156.04,218.21v16.34c0,.29-.23.51-.51.51h-20.04c-.29,0-.51-.23-.51-.51v-20.04c0-.29.23-.51.51-.51h20.04c.29,0,.51.23.51.51v3.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.83,226.63v-7.53c0-.49-.4-.9-.9-.9h-10.85c-.49,0-.9.4-.9.9v10.85c0,.49.4.9.9.9h10.85c.49,0,.9-.4.9-.9v-3.32Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.96,302.47c-.49,0-.9.4-.9.9v27.71c0,.49.4.9.9.9h27.71c.49,0,.9-.4.9-.9v-27.71c0-.49-.4-.9-.9-.9h-27.71ZM63.35,310.9v16.34c0,.29-.23.51-.51.51h-20.04c-.29,0-.51-.23-.51-.51v-20.04c0-.29.23-.51.51-.51h20.04c.29,0,.51.23.51.51v3.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.13,319.33v-7.53c0-.49-.4-.9-.9-.9h-10.85c-.49,0-.9.4-.9.9v10.85c0,.49.4.9.9.9h10.85c.49,0,.9-.4.9-.9v-3.32Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(39.62 198.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Use "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 15.21,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 19.71,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 24.05,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 28.5,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.85,
    y: 0
  }, "e ca"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 47.25,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.95,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 58.3,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.26,
    y: 0
  }, "a or "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 76.12,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    x: 81.12,
    y: 0
  }, "oogle Lens"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(54.13 166.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 6.94,
    y: 0
  }, "ALL")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 38.25,
    y: 156.36,
    width: 12.92,
    height: 12.92,
    rx: 2.04,
    ry: 2.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.27,158.81c.58-.57,1.53-.47,2.01.17l.6.8c.39.53.36,1.26-.11,1.72l-.11.11s-.02.06,0,.15c.03.19.19.6.87,1.28.68.67,1.09.83,1.29.86.09.01.14,0,.15,0l.19-.19c.42-.41,1.05-.49,1.57-.21l.91.49c.78.42.97,1.48.34,2.11l-.67.67c-.21.21-.5.39-.85.42-.86.08-2.86-.02-4.96-2.11-1.96-1.95-2.34-3.65-2.39-4.49l.36-.02-.36.02c-.02-.42.18-.78.43-1.04l.74-.74ZM42.71,159.41c-.24-.32-.69-.35-.94-.1l-.74.74c-.16.16-.23.33-.22.49.04.67.34,2.2,2.18,4.03,1.93,1.92,3.71,1.97,4.39,1.91.14-.01.28-.09.41-.22l.67-.67c.27-.27.21-.77-.17-.98l-.91-.49c-.25-.14-.54-.09-.73.09l-.22.21-.25-.25q.25.25.25.25h0s0,0,0,0h0s0,0,0,0c0,0-.01,0-.02.01-.01.01-.03.02-.05.04-.04.03-.09.05-.15.08-.13.05-.3.07-.51.04-.41-.06-.96-.34-1.68-1.06-.72-.72-1.01-1.26-1.07-1.67-.03-.21,0-.38.04-.51.02-.06.05-.11.08-.15.01-.02.02-.03.04-.05,0,0,.01-.01.01-.02h0s0,0,0,0h0s0,0,0,0t.25.25l-.25-.25.14-.14c.2-.2.23-.54.04-.79l-.6-.8Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(109.78 166.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 0,
    y: 0
  }, "MESS"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 28.78,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 35.88,
    y: 0
  }, "GE")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 93.44,
    y: 156.36,
    width: 12.92,
    height: 12.92,
    rx: 2.04,
    ry: 2.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.03,166.95c-.07,0-.14-.02-.21-.05l-1.53-.76c-.09-.05-.14-.07-.18-.08-.03,0-.05-.02-.08-.02-.03,0-.09,0-.19,0h-4.61c-.57,0-.88,0-1.18-.15-.26-.13-.47-.34-.6-.6-.15-.29-.15-.61-.15-1.18v-3.49c0-.57,0-.88.15-1.18.13-.26.34-.47.6-.6.29-.15.61-.15,1.18-.15h5.32c.57,0,.88,0,1.18.15.26.13.47.34.6.6.15.29.15.61.15,1.18v5.87c0,.16-.08.31-.22.39-.07.05-.16.07-.24.07ZM97.24,159.61c-.4,0-.66,0-.76.05-.09.04-.16.11-.2.2-.05.1-.05.36-.05.76v3.49c0,.4,0,.66.05.76.04.09.11.16.2.2.1.05.36.05.76.05h4.61c.14,0,.23,0,.32.01.08.01.17.03.25.06.09.03.17.07.29.13l.86.43v-5.13c0-.4,0-.66-.05-.76-.04-.09-.11-.16-.2-.2-.1-.05-.36-.05-.76-.05h-5.32ZM101.74,162.82h0c-.25,0-.46-.21-.46-.46s.21-.46.46-.46h0c.25,0,.46.21.46.46s-.21.46-.46.46ZM99.9,162.82h0c-.25,0-.46-.21-.46-.46s.21-.46.46-.46h0c.25,0,.46.21.46.46s-.21.46-.46.46ZM98.07,162.82h0c-.25,0-.46-.21-.46-.46s.21-.46.46-.46h0c.25,0,.46.21.46.46s-.21.46-.46.46Z"
  }))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "translate(23.14 78.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 17,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.68,
    y: 0
  }, "AN QR "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 117.96,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 134.14,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.37,
    y: 35.23
  }, "CON"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 66.32,
    y: 35.23
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 86.69,
    y: 35.23
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 112.74,
    y: 35.23
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 136.15,
    y: 35.23
  }, "T")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 10.53,
    y: 68.6
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 34.05,
    y: 68.6
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 69.06,
    y: 68.6
  }, "NER")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(36.7 349.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 5.62,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 10.43,
    y: 0
  }, "t "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 15.51,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 19.56,
    y: 0
  }, "our "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 34.54,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 39.35,
    y: 0
  }, "wn QR tag "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 80.02,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 84.66,
    y: 0
  }, "t SIDE"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 108.65,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 114.29,
    y: 0
  }, ".IN"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.29,16.66c-.62,0-1.15.21-1.57.63-.43.42-.64.94-.64,1.56s.21,1.17.64,1.59c.43.42.95.63,1.57.63s1.14-.21,1.56-.63.63-.95.63-1.59-.21-1.14-.63-1.56-.94-.63-1.56-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.56,22.44h-2.62c-.22,0-.39.12-.39.27v12.54c0,.15.18.27.39.27h2.62c.22,0,.39-.12.39-.27v-12.54c0-.15-.18-.27-.39-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.36,16.66h-2.62c-.22,0-.39.18-.39.39v4.37c0,.15-.18.24-.3.15-1.32-1.05-2.85-1.58-4.58-1.58-1.39,0-2.69.35-3.9,1.04-1.21.7-2.17,1.65-2.89,2.86-.72,1.21-1.08,2.54-1.08,4s.36,2.79,1.08,4c.72,1.21,1.68,2.17,2.89,2.87,1.21.71,2.51,1.06,3.9,1.06,1.75,0,3.27-.53,4.58-1.6.12-.1.3-.01.3.14v.78c0,.22.18.39.39.39h2.62c.22,0,.39-.18.39-.39v-18.08c0-.22-.18-.39-.39-.39ZM106.72,30.25c-.42.72-.98,1.29-1.69,1.72-.71.43-1.49.64-2.34.64s-1.61-.21-2.31-.64c-.71-.43-1.27-1-1.69-1.72-.42-.72-.63-1.5-.63-2.36s.21-1.61.63-2.33c.42-.72.98-1.29,1.69-1.72.71-.43,1.48-.64,2.31-.64s1.64.21,2.34.63c.71.42,1.27.99,1.69,1.72.42.73.63,1.51.63,2.34s-.21,1.64-.63,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.37,20.87c-1.18-.7-2.55-1.04-4.11-1.04-1.46,0-2.77.36-3.95,1.09-1.18.73-2.1,1.7-2.78,2.91-.67,1.21-1.01,2.51-1.01,3.9s.33,2.76.98,3.98c.65,1.22,1.59,2.2,2.83,2.94,1.23.74,2.68,1.11,4.35,1.11,1.41,0,2.65-.28,3.71-.83.94-.49,1.74-1.15,2.4-1.96.14-.17.11-.43-.06-.56l-1.73-1.35c-.16-.13-.4-.1-.54.05-.4.44-.9.8-1.5,1.08-.73.33-1.52.5-2.38.5-1.24,0-2.27-.35-3.1-1.06-.77-.66-1.29-1.52-1.54-2.56-.03-.1.06-.2.16-.2h11.52c.21,0,.38-.16.39-.37l.04-.67s0-.02,0-.03c0-1.49-.32-2.84-.96-4.05-.64-1.21-1.55-2.16-2.73-2.86ZM124.43,26.34h-8.25c-.11,0-.19-.1-.16-.21.27-.95.78-1.71,1.52-2.28.79-.61,1.73-.92,2.83-.92,1.22,0,2.19.3,2.92.9.68.56,1.12,1.33,1.31,2.31.02.1-.06.2-.16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.87,23.79c-.72-1.21-1.7-2.17-2.94-2.89-1.24-.72-2.6-1.08-4.08-1.08s-2.83.36-4.06,1.08c-1.23.72-2.2,1.69-2.92,2.91-.72,1.22-1.08,2.55-1.08,3.98s.36,2.76,1.08,3.98c.72,1.22,1.69,2.19,2.92,2.91,1.23.72,2.58,1.08,4.06,1.08s2.84-.36,4.08-1.08c1.24-.72,2.22-1.69,2.94-2.91.72-1.22,1.08-2.55,1.08-3.98s-.36-2.79-1.08-4ZM141.87,30.13c-.41.73-.96,1.31-1.67,1.73-.71.43-1.49.64-2.34.64s-1.64-.21-2.34-.64c-.71-.43-1.26-1.01-1.65-1.73-.4-.73-.59-1.51-.59-2.34s.2-1.61.59-2.33c.4-.72.95-1.29,1.65-1.72.71-.43,1.49-.64,2.34-.64s1.66.21,2.36.64c.7.43,1.25,1,1.65,1.72.41.72.61,1.49.61,2.33s-.2,1.62-.61,2.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.75,35.88c-1.17,0-2.33-.23-3.44-.68-1-.41-1.86-1.02-2.56-1.81-.1-.11-.14-.25-.13-.39.01-.14.08-.27.18-.36l1.58-1.34c.11-.09.25-.14.39-.12.14.01.27.08.36.19.37.45.84.84,1.41,1.17.69.39,1.45.59,2.27.59.37,0,.73-.04,1.07-.11.33-.07.64-.19.91-.35.26-.16.48-.36.63-.62.15-.25.23-.57.23-.97,0-.64-.3-1.11-.92-1.42-.66-.33-1.64-.65-2.92-.95-.52-.13-1.05-.29-1.57-.47-.54-.19-1.03-.45-1.47-.78-.44-.33-.81-.75-1.09-1.25-.28-.5-.42-1.13-.42-1.86,0-.84.17-1.57.52-2.18.34-.61.79-1.11,1.35-1.49.55-.38,1.18-.67,1.88-.86.69-.18,1.42-.28,2.15-.28,1.1,0,2.19.22,3.22.65.91.39,1.66.93,2.21,1.62.18.23.15.55-.07.73l-1.52,1.29c-.11.09-.25.14-.39.12-.14-.02-.27-.09-.36-.21-.3-.39-.7-.73-1.17-1-.59-.34-1.26-.51-2-.51-.33,0-.66.04-.99.11-.32.07-.61.18-.86.33-.24.15-.44.33-.59.56-.14.22-.21.49-.21.82,0,.58.25,1,.78,1.28.56.3,1.42.58,2.55.83.73.17,1.42.38,2.04.61.63.24,1.19.54,1.66.9.48.37.85.81,1.12,1.32.27.51.4,1.12.4,1.81,0,.92-.18,1.71-.53,2.35-.35.64-.83,1.17-1.41,1.58-.58.41-1.25.7-1.99.87-.74.17-1.5.26-2.28.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M64.76,31.56h-9.23c-1.55,0-2.81-1.26-2.81-2.81v-9.23c0-1.55,1.26-2.81,2.81-2.81h16.5c.56,0,.85.66.47,1.07l-4.36,4.11c-.37.39-.57.91-.57,1.45v5.39c0,1.55-1.26,2.81-2.81,2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M60.64,20.98h9.23c1.55,0,2.81,1.26,2.81,2.81v9.23c0,1.55-1.26,2.81-2.81,2.81h-16.5c-.56,0-.85-.66-.47-1.07l4.36-4.11c.37-.39.57-.91.57-1.45v-5.39c0-1.55,1.26-2.81,2.81-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.64,20.98c-1.55,0-2.81,1.26-2.81,2.81v5.39c0,.54-.2,1.06-.57,1.45l-.99.93h8.48c1.55,0,2.81-1.26,2.81-2.81v-5.39c0-.54.2-1.06.57-1.45l.99-.93h-8.48Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M65.39,24.56h-5.39c-.27,0-.49-.22-.49-.49s.22-.49.49-.49h5.39c.27,0,.49.22.49.49s-.22.49-.49.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M65.39,26.76h-5.39c-.27,0-.49-.22-.49-.49s.22-.49.49-.49h5.39c.27,0,.49.22.49.49s-.22.49-.49.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M63.41,28.97h-3.41c-.27,0-.49-.22-.49-.49s.22-.49.49-.49h3.41c.27,0,.49.22.49.49s-.22.49-.49.49Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.38,43.62c-.29-.12-.51-.3-.67-.52-.16-.23-.23-.49-.23-.79v-.22c0-.05.03-.08.08-.08h.56c.05,0,.08.03.08.08v.18c0,.26.11.48.34.65.23.17.53.25.93.25.35,0,.62-.07.8-.22.18-.15.27-.34.27-.58,0-.16-.05-.29-.14-.41-.09-.11-.23-.22-.4-.31-.18-.09-.43-.21-.77-.34-.37-.14-.67-.27-.89-.39s-.4-.27-.54-.46c-.14-.19-.22-.43-.22-.73,0-.44.16-.79.47-1.04.31-.25.74-.38,1.28-.38.38,0,.71.06,1,.19.29.13.51.31.66.54.16.23.23.5.23.8v.15c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-.12c0-.27-.11-.49-.32-.66s-.51-.26-.88-.26c-.32,0-.56.07-.74.2-.17.13-.26.32-.26.56,0,.17.04.31.13.41.09.11.22.2.39.29.17.08.43.19.79.33.36.14.66.28.88.4.23.12.41.28.56.48.15.2.22.44.22.73,0,.45-.17.81-.5,1.07-.33.26-.78.4-1.36.4-.39,0-.74-.06-1.03-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.99,40.44h-.83s-.03.01-.03.03v2.04c0,.22.05.37.15.46.1.09.25.14.45.14h.22c.05,0,.08.03.08.08v.48c0,.05-.03.08-.08.08-.16.01-.28.02-.35.02-.39,0-.68-.07-.88-.21-.2-.14-.3-.4-.3-.78v-2.3s-.01-.03-.03-.03h-.47c-.05,0-.08-.03-.08-.08v-.45c0-.05.03-.08.08-.08h.47s.03-.01.03-.03v-.91c0-.05.03-.08.08-.08h.55c.05,0,.08.03.08.08v.91s.01.03.03.03h.83c.05,0,.08.03.08.08v.45c0,.05-.03.08-.08.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.18,39.94c.23.11.41.26.54.46.13.2.19.42.19.67v2.6c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-.28s-.01-.03-.04-.02c-.13.14-.3.24-.49.32-.19.07-.41.11-.64.11-.38,0-.69-.1-.94-.29-.25-.19-.37-.48-.37-.87s.14-.71.42-.94c.28-.23.67-.34,1.17-.34h.86s.03-.01.03-.03v-.21c0-.23-.07-.4-.2-.53s-.33-.19-.6-.19c-.22,0-.39.04-.53.13s-.22.2-.25.34c-.02.05-.05.07-.09.07l-.62-.08c-.05-.01-.07-.03-.07-.06.04-.3.2-.55.48-.74.28-.19.63-.29,1.06-.29.31,0,.58.06.82.17ZM61.87,42.97c.2-.14.3-.32.3-.55v-.45s-.01-.03-.03-.03h-.72c-.3,0-.54.06-.72.18-.18.12-.27.28-.27.49,0,.19.07.33.2.43.14.1.31.15.53.15.27,0,.51-.07.71-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.62,45.2v-.45c0-.05.03-.08.08-.08h.02c.2,0,.37-.03.48-.08.12-.05.22-.13.29-.26.08-.13.15-.31.22-.56,0,0,0-.02,0-.05l-1.28-3.8v-.03s.02-.05.06-.05h.62s.08.02.09.06l.87,2.9s.01.02.02.02.02,0,.02-.02l.86-2.9s.05-.06.09-.06h.61c.06,0,.08.03.06.08l-1.4,4.09c-.12.35-.24.62-.35.79s-.27.29-.46.36c-.19.07-.46.11-.8.11h-.05s-.05-.03-.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.98,43.69l-1.08-2.3s-.02-.02-.03-.02h-1.11s-.03.01-.03.03v2.27c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-5.22c0-.05.03-.08.08-.08h2.07c.31,0,.58.06.81.19.23.13.41.31.54.54.13.23.19.5.19.8,0,.36-.09.66-.28.91-.19.25-.45.42-.78.5-.02.01-.03.02-.02.04l1.11,2.3s0,.02,0,.04c0,.04-.02.05-.06.05h-.61s-.07-.02-.08-.05ZM69.74,39.04v1.72s.01.03.03.03h1.28c.27,0,.49-.08.65-.24.16-.16.25-.38.25-.64s-.08-.49-.25-.65c-.16-.16-.38-.25-.65-.25h-1.28s-.03.01-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.73,42.01c0,.05-.03.08-.08.08h-2.45s-.03.01-.03.03c0,.17.02.31.05.4.06.2.17.36.34.48.17.12.39.17.65.17.38,0,.67-.16.88-.47.03-.05.06-.06.1-.02l.44.29s.04.06.02.1c-.14.23-.35.41-.61.55-.26.13-.56.2-.89.2-.37,0-.69-.08-.94-.25-.26-.16-.45-.4-.58-.7-.12-.3-.18-.67-.18-1.1,0-.37.03-.66.08-.85.09-.35.28-.63.55-.84.28-.2.61-.31,1.01-.31.52,0,.9.13,1.16.39.26.26.41.64.47,1.14.02.21.03.45.02.71ZM74.54,40.58c-.14.11-.24.26-.29.44-.04.11-.06.26-.07.43,0,.02.01.03.03.03h1.76s.03-.01.03-.03c-.01-.17-.03-.29-.05-.38-.05-.2-.15-.36-.3-.48-.15-.12-.34-.18-.56-.18s-.4.06-.55.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.83,39.94c.23.11.41.26.54.46.13.2.19.42.19.67v2.6c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-.28s-.01-.03-.04-.02c-.13.14-.3.24-.49.32-.19.07-.41.11-.64.11-.38,0-.69-.1-.94-.29-.25-.19-.37-.48-.37-.87s.14-.71.42-.94c.28-.23.67-.34,1.17-.34h.86s.03-.01.03-.03v-.21c0-.23-.07-.4-.2-.53s-.33-.19-.6-.19c-.22,0-.39.04-.53.13s-.22.2-.25.34c-.02.05-.05.07-.09.07l-.62-.08c-.05-.01-.07-.03-.07-.06.04-.3.2-.55.48-.74.28-.19.63-.29,1.06-.29.31,0,.58.06.82.17ZM79.52,42.97c.2-.14.3-.32.3-.55v-.45s-.01-.03-.03-.03h-.72c-.3,0-.54.06-.72.18-.18.12-.27.28-.27.49,0,.19.07.33.2.43.14.1.31.15.53.15.27,0,.51-.07.71-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.09,43.51c-.28-.2-.47-.46-.57-.8-.08-.24-.12-.55-.12-.93,0-.35.04-.66.12-.93.1-.33.29-.59.57-.78.28-.19.61-.29.99-.29s.72.1,1.01.29c.29.19.47.44.56.74.03.08.05.17.06.25,0,.04-.02.07-.07.08l-.58.08h-.02s-.06-.02-.08-.07l-.02-.12c-.04-.17-.14-.32-.3-.44-.16-.12-.35-.18-.58-.18s-.41.06-.56.18c-.15.12-.25.27-.3.47-.05.18-.07.43-.07.73s.02.54.07.72c.05.2.15.37.3.48.15.12.34.18.56.18s.42-.06.58-.18c.16-.12.26-.27.3-.46,0,0,0-.01,0-.02,0,0,0-.01,0-.02v-.03s.04-.06.08-.05l.58.09s.06.03.06.06v.03s-.01.1-.04.17c-.09.31-.27.56-.56.75-.29.19-.62.28-1.01.28s-.72-.1-1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.26,40.15c.25.24.37.57.37.99v2.53c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-2.39c0-.26-.07-.46-.22-.62s-.35-.24-.59-.24-.44.08-.59.24-.23.36-.23.61v2.4c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-5.22c0-.05.03-.08.08-.08h.58c.05,0,.08.03.08.08v1.74s0,.02.01.02c0,0,.01,0,.02,0,.22-.28.55-.42.98-.42s.75.12,1,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.89,39.94c.23.11.41.26.54.46.13.2.19.42.19.67v2.6c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-.28s-.01-.03-.04-.02c-.13.14-.3.24-.49.32-.19.07-.41.11-.64.11-.38,0-.69-.1-.94-.29-.25-.19-.37-.48-.37-.87s.14-.71.42-.94c.28-.23.67-.34,1.17-.34h.86s.03-.01.03-.03v-.21c0-.23-.07-.4-.2-.53s-.33-.19-.6-.19c-.22,0-.39.04-.53.13s-.22.2-.25.34c-.02.05-.05.07-.09.07l-.62-.08c-.05-.01-.07-.03-.07-.06.04-.3.2-.55.48-.74.28-.19.63-.29,1.06-.29.31,0,.58.06.82.17ZM91.58,42.97c.2-.14.3-.32.3-.55v-.45s-.01-.03-.03-.03h-.72c-.3,0-.54.06-.72.18-.18.12-.27.28-.27.49,0,.19.07.33.2.43.14.1.31.15.53.15.27,0,.51-.07.71-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.85,41.78c0,.38-.05.71-.15.98-.11.33-.29.59-.53.77-.24.18-.55.27-.92.27-.18,0-.35-.04-.5-.11-.15-.07-.29-.17-.4-.3-.01-.01-.02-.01-.03,0,0,0-.01.01-.01.02v.25c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-5.22c0-.05.03-.08.08-.08h.58c.05,0,.08.03.08.08v1.71s0,.02.01.02c0,0,.02,0,.03,0,.11-.13.25-.23.4-.3.16-.07.32-.1.5-.1.38,0,.7.09.94.28.25.19.42.45.53.79.08.26.12.57.12.93ZM96.11,41.79c0-.42-.08-.76-.25-1.01-.15-.25-.38-.37-.68-.37-.29,0-.5.13-.65.39-.13.24-.2.56-.2.98s.06.74.18.97c.15.28.38.41.68.41.34,0,.58-.14.73-.42.13-.24.19-.56.19-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.78,43.67v-5.22c0-.05.03-.08.08-.08h.58c.05,0,.08.03.08.08v5.22c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.74,42.01c0,.05-.03.08-.08.08h-2.45s-.03.01-.03.03c0,.17.02.31.05.4.06.2.17.36.34.48.17.12.39.17.65.17.38,0,.67-.16.88-.47.03-.05.06-.06.1-.02l.44.29s.04.06.02.1c-.14.23-.35.41-.61.55-.26.13-.56.2-.89.2-.37,0-.69-.08-.94-.25-.26-.16-.45-.4-.58-.7-.12-.3-.18-.67-.18-1.1,0-.37.03-.66.08-.85.09-.35.28-.63.55-.84.28-.2.61-.31,1.01-.31.52,0,.9.13,1.16.39.26.26.41.64.47,1.14.02.21.03.45.02.71ZM100.54,40.58c-.14.11-.24.26-.29.44-.04.11-.06.26-.07.43,0,.02.01.03.03.03h1.76s.03-.01.03-.03c-.01-.17-.03-.29-.05-.38-.05-.2-.15-.36-.3-.48-.15-.12-.34-.18-.56-.18s-.4.06-.55.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.62,43.61c-.09-.09-.14-.21-.14-.35s.05-.26.14-.35.21-.14.35-.14.26.05.35.14.14.21.14.35-.05.26-.14.35-.21.14-.35.14-.26-.05-.35-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.77,43.62c-.29-.12-.51-.3-.67-.52-.16-.23-.23-.49-.23-.79v-.22c0-.05.03-.08.08-.08h.56c.05,0,.08.03.08.08v.18c0,.26.11.48.34.65.23.17.53.25.93.25.35,0,.62-.07.8-.22.18-.15.27-.34.27-.58,0-.16-.05-.29-.14-.41-.09-.11-.23-.22-.4-.31-.18-.09-.43-.21-.77-.34-.37-.14-.67-.27-.89-.39s-.4-.27-.54-.46c-.14-.19-.22-.43-.22-.73,0-.44.16-.79.47-1.04.31-.25.74-.38,1.28-.38.38,0,.71.06,1,.19.29.13.51.31.66.54.16.23.23.5.23.8v.15c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-.12c0-.27-.11-.49-.32-.66s-.51-.26-.88-.26c-.32,0-.56.07-.74.2-.17.13-.26.32-.26.56,0,.17.04.31.13.41.09.11.22.2.39.29.17.08.43.19.79.33.36.14.66.28.88.4.23.12.41.28.56.48.15.2.22.44.22.73,0,.45-.17.81-.5,1.07-.33.26-.78.4-1.36.4-.39,0-.74-.06-1.03-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.37,40.44h-.83s-.03.01-.03.03v2.04c0,.22.05.37.15.46.1.09.25.14.45.14h.22c.05,0,.08.03.08.08v.48c0,.05-.03.08-.08.08-.16.01-.28.02-.35.02-.39,0-.68-.07-.88-.21-.2-.14-.3-.4-.3-.78v-2.3s-.01-.03-.03-.03h-.47c-.05,0-.08-.03-.08-.08v-.45c0-.05.03-.08.08-.08h.47s.03-.01.03-.03v-.91c0-.05.03-.08.08-.08h.55c.05,0,.08.03.08.08v.91s.01.03.03.03h.83c.05,0,.08.03.08.08v.45c0,.05-.03.08-.08.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,39.94c.23.11.41.26.54.46.13.2.19.42.19.67v2.6c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-.28s-.01-.03-.04-.02c-.13.14-.3.24-.49.32-.19.07-.41.11-.64.11-.38,0-.69-.1-.94-.29-.25-.19-.37-.48-.37-.87s.14-.71.42-.94c.28-.23.67-.34,1.17-.34h.86s.03-.01.03-.03v-.21c0-.23-.07-.4-.2-.53s-.33-.19-.6-.19c-.22,0-.39.04-.53.13s-.22.2-.25.34c-.02.05-.05.07-.09.07l-.62-.08c-.05-.01-.07-.03-.07-.06.04-.3.2-.55.48-.74.28-.19.63-.29,1.06-.29.31,0,.58.06.82.17ZM116.25,42.97c.2-.14.3-.32.3-.55v-.45s-.01-.03-.03-.03h-.72c-.3,0-.54.06-.72.18-.18.12-.27.28-.27.49,0,.19.07.33.2.43.14.1.31.15.53.15.27,0,.51-.07.71-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.01,45.2v-.45c0-.05.03-.08.08-.08h.02c.2,0,.37-.03.48-.08.12-.05.22-.13.29-.26.08-.13.15-.31.22-.56,0,0,0-.02,0-.05l-1.28-3.8v-.03s.02-.05.06-.05h.62s.08.02.09.06l.87,2.9s.01.02.02.02.02,0,.02-.02l.86-2.9s.05-.06.09-.06h.61c.06,0,.08.03.06.08l-1.4,4.09c-.12.35-.24.62-.35.79s-.27.29-.46.36c-.19.07-.46.11-.8.11h-.05s-.05-.03-.05-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.32,38.56c.24.13.42.31.55.55.13.24.2.51.2.81s-.07.58-.2.81c-.13.23-.32.41-.56.54s-.52.19-.84.19h-1.35s-.03.01-.03.03v2.18c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-5.23c0-.05.03-.08.08-.08h2.07c.31,0,.59.07.83.2ZM126.07,40.6c.17-.17.26-.39.26-.67s-.09-.51-.26-.68c-.17-.17-.4-.26-.68-.26h-1.28s-.03.01-.03.03v1.8s.01.03.03.03h1.28c.28,0,.51-.08.68-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.97,39.9s.05.05.04.09l-.12.58s-.04.06-.09.05c-.09-.04-.19-.05-.31-.05h-.11c-.24.02-.44.1-.6.26-.16.16-.23.36-.23.61v2.24c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-3.76c0-.05.03-.08.08-.08h.58c.05,0,.08.03.08.08v.41s0,.02.01.03c0,0,.01,0,.02-.01.23-.36.55-.54.94-.54.16,0,.31.03.45.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.72,39.08c-.09-.09-.14-.21-.14-.35s.05-.26.14-.35.21-.14.35-.14.26.05.35.14.14.21.14.35-.05.26-.14.35-.21.14-.35.14-.26-.05-.35-.14ZM130.68,43.66v-3.75c0-.05.03-.08.08-.08h.58c.05,0,.08.03.08.08v3.75c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.48,43.68l-1.25-3.76v-.03s.02-.05.06-.05h.65s.08.02.09.06l.84,2.78s.01.02.02.02.02,0,.02-.02l.84-2.78s.05-.06.09-.06h.65c.06,0,.08.04.06.09l-1.24,3.76s-.05.06-.09.06h-.65s-.08-.02-.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.39,39.94c.23.11.41.26.54.46.13.2.19.42.19.67v2.6c0,.05-.03.08-.08.08h-.58c-.05,0-.08-.03-.08-.08v-.28s-.01-.03-.04-.02c-.13.14-.3.24-.49.32-.19.07-.41.11-.64.11-.38,0-.69-.1-.94-.29-.25-.19-.37-.48-.37-.87s.14-.71.42-.94c.28-.23.67-.34,1.17-.34h.86s.03-.01.03-.03v-.21c0-.23-.07-.4-.2-.53s-.33-.19-.6-.19c-.22,0-.39.04-.53.13s-.22.2-.25.34c-.02.05-.05.07-.09.07l-.62-.08c-.05-.01-.07-.03-.07-.06.04-.3.2-.55.48-.74.28-.19.63-.29,1.06-.29.31,0,.58.06.82.17ZM138.08,42.97c.2-.14.3-.32.3-.55v-.45s-.01-.03-.03-.03h-.72c-.3,0-.54.06-.72.18-.18.12-.27.28-.27.49,0,.19.07.33.2.43.14.1.31.15.53.15.27,0,.51-.07.71-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.87,40.44h-.83s-.03.01-.03.03v2.04c0,.22.05.37.15.46.1.09.25.14.45.14h.22c.05,0,.08.03.08.08v.48c0,.05-.03.08-.08.08-.16.01-.28.02-.35.02-.39,0-.68-.07-.88-.21-.2-.14-.3-.4-.3-.78v-2.3s-.01-.03-.03-.03h-.47c-.05,0-.08-.03-.08-.08v-.45c0-.05.03-.08.08-.08h.47s.03-.01.03-.03v-.91c0-.05.03-.08.08-.08h.55c.05,0,.08.03.08.08v.91s.01.03.03.03h.83c.05,0,.08.03.08.08v.45c0,.05-.03.08-.08.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.91,42.01c0,.05-.03.08-.08.08h-2.45s-.03.01-.03.03c0,.17.02.31.05.4.06.2.17.36.34.48.17.12.39.17.65.17.38,0,.67-.16.88-.47.03-.05.06-.06.1-.02l.44.29s.04.06.02.1c-.14.23-.35.41-.61.55-.26.13-.56.2-.89.2-.37,0-.69-.08-.94-.25-.26-.16-.45-.4-.58-.7-.12-.3-.18-.67-.18-1.1,0-.37.03-.66.08-.85.09-.35.28-.63.55-.84.28-.2.61-.31,1.01-.31.52,0,.9.13,1.16.39.26.26.41.64.47,1.14.02.21.03.45.02.71ZM143.72,40.58c-.14.11-.24.26-.29.44-.04.11-.06.26-.07.43,0,.02.01.03.03.03h1.76s.03-.01.03-.03c-.01-.17-.03-.29-.05-.38-.05-.2-.15-.36-.3-.48-.15-.12-.34-.18-.56-.18s-.4.06-.55.17Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.64,272.35c-.32,0-.6.11-.82.33-.22.22-.33.49-.33.81s.11.61.33.83c.22.22.5.33.82.33s.59-.11.81-.33.33-.49.33-.83-.11-.59-.33-.81-.49-.33-.81-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.3,275.36h-1.36c-.11,0-.21.06-.21.14v6.54c0,.08.09.14.21.14h1.36c.11,0,.21-.06.21-.14v-6.54c0-.08-.09-.14-.21-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.57,272.35h-1.36c-.11,0-.21.09-.21.21v2.28c0,.08-.09.13-.16.08-.69-.55-1.49-.82-2.39-.82-.73,0-1.4.18-2.03.54-.63.36-1.13.86-1.51,1.49-.37.63-.56,1.32-.56,2.08s.19,1.45.56,2.08c.37.63.88,1.13,1.51,1.5.63.37,1.31.55,2.03.55.91,0,1.71-.28,2.39-.84.06-.05.16,0,.16.07v.4c0,.11.09.21.21.21h1.36c.11,0,.21-.09.21-.21v-9.42c0-.11-.09-.21-.21-.21ZM97.68,279.43c-.22.37-.51.67-.88.9-.37.22-.78.33-1.22.33s-.84-.11-1.2-.33c-.37-.22-.66-.52-.88-.9-.22-.37-.33-.78-.33-1.23s.11-.84.33-1.21c.22-.37.51-.67.88-.9.37-.22.77-.33,1.2-.33s.85.11,1.22.33c.37.22.66.52.88.9.22.38.33.79.33,1.22s-.11.86-.33,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.88,274.54c-.61-.36-1.33-.54-2.14-.54-.76,0-1.44.19-2.06.57-.61.38-1.1.88-1.45,1.51-.35.63-.53,1.31-.53,2.03s.17,1.44.51,2.07c.34.64.83,1.15,1.47,1.53.64.38,1.4.58,2.27.58.74,0,1.38-.15,1.93-.44.49-.26.91-.6,1.25-1.02.07-.09.06-.22-.03-.29l-.9-.7c-.09-.07-.21-.05-.28.03-.21.23-.47.42-.78.56-.38.17-.79.26-1.24.26-.65,0-1.19-.18-1.61-.55-.4-.35-.67-.79-.8-1.33-.01-.05.03-.11.09-.11h6.01c.11,0,.2-.08.21-.19l.02-.35s0-.01,0-.02c0-.78-.17-1.48-.5-2.11-.33-.63-.81-1.13-1.42-1.49ZM106.91,277.4h-4.3c-.06,0-.1-.05-.08-.11.14-.49.41-.89.79-1.19.41-.32.9-.48,1.47-.48.64,0,1.14.16,1.52.47.36.29.58.69.68,1.2.01.05-.03.1-.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.56,276.07c-.37-.63-.88-1.13-1.53-1.51-.65-.37-1.36-.56-2.13-.56s-1.48.19-2.12.56c-.64.37-1.15.88-1.52,1.51-.37.64-.56,1.33-.56,2.07s.19,1.44.56,2.08c.37.64.88,1.14,1.52,1.51.64.37,1.35.56,2.12.56s1.48-.19,2.13-.56c.65-.37,1.16-.88,1.53-1.51.37-.64.56-1.33.56-2.08s-.19-1.45-.56-2.08ZM116,279.37c-.21.38-.5.68-.87.9-.37.22-.78.33-1.22.33s-.85-.11-1.22-.33c-.37-.22-.66-.52-.86-.9-.21-.38-.31-.79-.31-1.22s.1-.84.31-1.21c.21-.37.49-.67.86-.9.37-.22.78-.33,1.22-.33s.87.11,1.23.33c.36.22.65.52.86.9.21.37.32.78.32,1.21s-.11.84-.32,1.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.67,282.37c-.61,0-1.21-.12-1.79-.36-.52-.21-.97-.53-1.33-.94-.05-.06-.07-.13-.07-.2,0-.07.04-.14.1-.19l.82-.7c.06-.05.13-.07.2-.06.07,0,.14.04.19.1.19.24.44.44.74.61.36.2.76.31,1.18.31.19,0,.38-.02.56-.06.17-.04.33-.1.47-.18.14-.08.25-.19.33-.32.08-.13.12-.3.12-.5,0-.33-.16-.58-.48-.74-.34-.17-.85-.34-1.52-.49-.27-.07-.55-.15-.82-.24-.28-.1-.54-.23-.77-.4-.23-.17-.42-.39-.57-.65-.15-.26-.22-.59-.22-.97,0-.44.09-.82.27-1.14.18-.32.41-.58.7-.78.29-.2.61-.35.98-.45.36-.1.74-.14,1.12-.14.58,0,1.14.11,1.68.34.48.2.86.49,1.15.85.09.12.08.29-.04.38l-.79.67c-.06.05-.13.07-.21.06-.08,0-.14-.05-.19-.11-.16-.21-.36-.38-.61-.52-.31-.17-.66-.26-1.04-.26-.17,0-.34.02-.52.06-.17.04-.32.1-.45.17-.13.08-.23.17-.31.29-.07.11-.11.26-.11.43,0,.3.13.52.4.67.29.16.74.3,1.33.43.38.09.74.2,1.06.32.33.13.62.28.86.47.25.19.44.42.58.69.14.27.21.58.21.94,0,.48-.09.89-.28,1.23-.18.33-.43.61-.74.82-.3.21-.65.36-1.04.46-.38.09-.78.14-1.19.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M101.38,266.63h-7.12c-1.2,0-2.17-.97-2.17-2.17v-7.12c0-1.2.97-2.17,2.17-2.17h12.74c.43,0,.65.51.36.83l-3.37,3.18c-.28.3-.44.71-.44,1.12v4.16c0,1.2-.97,2.17-2.17,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.21,258.45h7.12c1.2,0,2.17.97,2.17,2.17v7.12c0,1.2-.97,2.17-2.17,2.17h-12.74c-.43,0-.65-.51-.36-.83l3.37-3.18c.28-.3.44-.71.44-1.12v-4.16c0-1.2.97-2.17,2.17-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.21,258.45c-1.2,0-2.17.97-2.17,2.17v4.16c0,.42-.16.82-.44,1.12l-.76.72h6.55c1.2,0,2.17-.97,2.17-2.17v-4.16c0-.42.16-.82.44-1.12l.76-.72h-6.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M101.88,261.22h-4.16c-.21,0-.38-.17-.38-.38s.17-.38.38-.38h4.16c.21,0,.38.17.38.38s-.17.38-.38.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M101.88,262.92h-4.16c-.21,0-.38-.17-.38-.38s.17-.38.38-.38h4.16c.21,0,.38.17.38.38s-.17.38-.38.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M100.34,264.62h-2.63c-.21,0-.38-.17-.38-.38s.17-.38.38-.38h2.63c.21,0,.38.17.38.38s-.17.38-.38.38Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrTagVl);
export default __webpack_public_path__ + "static/media/QR Tag VL.480c58a8d803b68b88d30d6da464ed20.svg";
export { ForwardRef as ReactComponent };